import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Tabs, List, Divider, Typography } from "antd";

import { formateDate } from "../../utils/dateUtil";

import "./alumni-single-modal.css";
const { TabPane } = Tabs;
const { Text } = Typography;

class AdumniGraduateModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    alumni: PropTypes.object.isRequired,
  };

  state = {
    loading: false,
    item: {},
  };

  // constructor(props) {
  //     super(props)
  // }

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    //console.log(this.props.alumni);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  ///////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////
  render() {
    const {
      TwId,
      StudentId,
      AlumniName,
      Sex,
      Birthday,
      MobilePrincipal,
      MobileSpare,
      TelephonePrincipal,
      TelephoneSpare,
      EmailPrincipal,
      EmailSpare,
      MailingAddress,
      ResidentAddress,
      LastFinalUniversity,
      LastFinalDepartmentName,
      LastFinalDegree,
      ContinueLearnUniversity,
      ContinueLearnDepartmentName,
      ContinueLearnDegree,
      JobCompany,
      JobTitle,
      NowStatusModifyDateTime,
    } = this.props.alumni;
    return (
      <>
        <List>
          <List.Item>
            <Divider
              orientation="left"
              style={{ borderColor: "#7cb305" }}
              dashed
            >
              <i className="fas fa-male"></i> 個人資訊{" "}
              <Text mark>
                最後更新時間：{formateDate(NowStatusModifyDateTime)}
              </Text>
            </Divider>
            姓名： {AlumniName} <br />
            身份證字號： {TwId} <br />
            性別： {Sex} <br />
            生日： {Birthday} <br />
            學號：{StudentId} <br />
            學歷：
            {LastFinalDepartmentName !== ""
              ? LastFinalUniversity +
                "/" +
                LastFinalDepartmentName +
                "/" +
                LastFinalDegree
              : ""}
          </List.Item>
        </List>
        <Tabs defaultActiveKey="1" type="card" className="tabsStyle">
          <TabPane
            tab={
              <span>
                <i className="fas fa-indent"></i> 通訊資料
              </span>
            }
            key="2"
          >
            <List>
              <List.Item>
                <Divider orientation="left">
                  <i className="fas fa-phone-alt"></i> 電話
                </Divider>
                行動電話(主要)： {MobilePrincipal} <br />
                行動電話(備用)： {MobileSpare} <br />
                室內電話(主要)： {TelephonePrincipal}
                <br />
                室內電話(備用)： {TelephoneSpare}
                <br />
                <Divider orientation="left">
                  <i className="far fa-envelope-open"></i> 電子郵件
                </Divider>
                電子郵件信箱(主要)： {EmailPrincipal} <br />
                電子郵件信箱(備用)： {EmailSpare} <br />
                <Divider orientation="left">
                  <i className="fas fa-map-marked-alt"></i> 地址
                </Divider>
                通訊地址： {MailingAddress} <br />
                戶籍地址： {ResidentAddress} <br />
              </List.Item>
            </List>
          </TabPane>
          <TabPane
            tab={
              <span>
                <i className="fas fa-bezier-curve"></i> 其他紀錄
              </span>
            }
            key="3"
          >
            <Divider orientation="left">
              <i className="fas fa-clipboard-list"></i> 輔助紀錄
            </Divider>
            升學紀錄：{" "}
            {ContinueLearnDepartmentName !== ""
              ? ContinueLearnUniversity +
                "/" +
                ContinueLearnDepartmentName +
                "/" +
                ContinueLearnDegree
              : "無"}{" "}
            <br />
            工作紀錄： {JobCompany !== ""
              ? JobCompany + "/" + JobTitle
              : "無"}{" "}
            <br />
            其他紀錄： 無
          </TabPane>
        </Tabs>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AdumniGraduateModal);
